import script from "./PartnerSlides.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerSlides.vue?vue&type=script&setup=true&lang=js"

import "./PartnerSlides.vue?vue&type=style&index=0&id=6e818da3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e818da3"]])

export default __exports__